import React, { useEffect, useState } from "react";
import { IAuth } from "@Store";
import { AtlasForm, FormLayoutTypes } from "atlas-form";
import { fromJson } from "json-joi-converter";
import { patchUserTwinningSettings, userTwinningSettingsSchema } from "@Api";
import { TFunction } from "i18next";
import { message } from "antd";
import { tryCatch } from "@Utils/tryCatch";

interface IProps {
  auth: IAuth;
  t: TFunction;
  closeModal: () => void;
}

export const TwinningSettingsForm = React.memo(({ auth, t, closeModal }: IProps) => {
  const [initialValues] = useState(auth.user.voice_settings.twinning || {});
  const [schema, setSchema] = useState();

  useEffect(() => {
    userTwinningSettingsSchema().then((s) => setSchema(s));
  }, []);

  if (!schema) return <>{t("LOADING_FORM")}</>;

  return (
    <div style={{ width: "100%" }}>
      <AtlasForm
        formLayout={{
          id: "TWINNING_SETTINGS",
          ui_layout: FormLayoutTypes.HORIZONTAL,
          labelWidth: "240px",
        }}
        title="TWINNING"
        form={fromJson(schema)}
        initialValues={initialValues}
        onFinish={async (values) => {
          const { data, error } = await tryCatch(patchUserTwinningSettings(auth.user.id, values));
          if (data) {
            message.success(t("SETTINGS_SAVED_SUCCESSFULLY"));
            closeModal();
          } else if (error) {
            message.error(t("SETTINGS_SAVE_FAILED"));
          }
        }}
      />
    </div>
  );
});
